<template>
  <div
    class="mall-button"
    :class="['mall-button--' + type, 'mall-button--' + size, { 'mall-button--disabled': disabled || dimmed }]"
    @click="onClick"
  >
    <img v-if="icon" class="mall-button__icon" :src="icon" alt="" />
    <span class="mall-button__text">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'MallButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    // 'primary' | 'secondary' | 'soft' | 'error'
    type: {
      type: String,
      default: 'primary',
    },
    // 'lg'(54px) | 'md'(48px) | 'sm'(32px)
    size: {
      type: String,
      default: 'lg',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 비활성처럼 보이지만 누를 수 있음 (눌렀을 때 입력이 덜 된 이유를 안내할 때)
    dimmed: {
      type: Boolean,
      default: false,
    },
    // 글자 왼쪽 아이콘 (없으면 미노출)
    icon: {
      type: String,
      default: '',
    },
  },
  methods: {
    onClick() {
      if (this.disabled) return
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.mall-button {
  display: flex;
  flex: 1;
  min-width: 0;
  height: 54px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 14px;
  box-sizing: border-box;
  cursor: pointer;
}

.mall-button--primary {
  background: #0096FF;
  color: #FFF;
}

.mall-button--primary.mall-button--disabled {
  background: #C7E8FF;
  cursor: default;
}

.mall-button--secondary {
  background: #F2F4F6;
  color: var(--color-text-main);
}

.mall-button--soft {
  background: #EFF9FF;
  color: #0096FF;
}

/* 삭제 등 (Figma error/light, text/error) */
.mall-button--error {
  background: #FEE;
  color: #F04452;
}

.mall-button--md {
  height: 48px;
  border-radius: 12px;
}

.mall-button--sm {
  flex: none;
  height: 32px;
  padding: 0 8px;
  border-radius: 8px;
}

.mall-button__icon {
  display: block;
  flex-shrink: 0;
}

.mall-button__text {
  font-family: Pretendard;
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

.mall-button--md .mall-button__text {
  font-size: var(--font-size-md);
}

.mall-button--sm .mall-button__text {
  font-size: var(--font-size-sm);
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/MallButton.vue